import { MainHeader, SingleQuoteView } from "@/components";

export default function QuoteLinePage() {
  return (
    <>
      <MainHeader pageName="Quote line" />
      <div className="px-5">
        <SingleQuoteView />
      </div>
    </>
  );
}
